import salt_48 from '../assets/salt_48.png'
import styles from '../styles/Card.module.scss'
import { useSelector } from 'react-redux'

const CardSalt = ({ salt }) => {
  const firebaseSaltLevel = useSelector(
    (state) => state.firebase.profile.saltLevel
  )
  const localSaltLevel = useSelector((state) => state.settings.saltLevel)
  const saltLevel = firebaseSaltLevel || localSaltLevel
  const saltThreshold = saltLevel === 0 ? 9999 : saltLevel === 2 ? 0 : 2
  return (
    salt > saltThreshold && (
      <div className={styles.salty}>
        <img alt='Salt Score' src={salt_48} />
        <div className={styles.saltyTooltip}>
          <img alt='Salt Score' src={salt_48} />
          <div>Salt Score: {salt.toFixed(2)}</div>
        </div>
      </div>
    )
  )
}

export default CardSalt
